import {
  ProductCreate,
  ProductEdit,
  ProductList
} from 'pages/ecommerce/products';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'products',
  label: 'Produtos',
  list: ProductList,
  create: ProductCreate,
  edit: ProductEdit,
  actions: ['list', 'show', 'edit', 'create', 'slug'],
  parentName: 'ecommerce'
};

export default generateResources(resource);
